import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  AdddocumenttoOrder,
  FetchdocumentByOrderid,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Tooltip, Drawer, Empty } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import Loader from "../../components/Common/Loader";
import attach from "../../assets/icons/attach_fileSMS.svg";
import downloadDoc from "../../assets/icons/downloadDoc.svg";
import "../../assets/styles/local/AddPurchaseOrderDocument.css";
import {
  fileExtensionType,
  downloadFile,
} from "../../utils/helpers/FileExtensionType";
import roundFileSize from "../../utils/Documents/roundFileSize";
import DocumentUploaderWithProgress22 from "../../components/Common/Document_Uploader_With_Progress22";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

const AddPurchaseOrderDocument = ({
  isDisabled = false,
  orderid,
  childData,
  style,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);

  const multipleUploadToS3Res = useSelector(
    (state) => state.user.multipleUploadToS3Res,
  );

  const addDocumentToOrderRes = useSelector(
    (state) => state.user.addDocumentToOrderRes,
  );

  const fetchDocumentByOrderIDRes = useSelector(
    (state) => state.user.fetchDocumentByOrderIDRes,
  );

  const addPurchasingOrder = useSelector(
    (state) => state.user.addPurchasingOrder,
  );
  const sendEmailPurchasingOrder = useSelector(
    (state) => state.user.sendEmailPurchasingOrder,
  );

  const [attachments, setAttachments] = useState([]);
  const [documentID, setDocumentID] = useState("");
  const [multiDocumentID, setMultiDocumentID] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  console.log("asc attachments", attachments);

  useEffect(() => {
    if (orderid) {
      dispatch(FetchdocumentByOrderid({ orderid: orderid })).then((res) => {
        if (res?.status === true) {
          setAttachments(res.data);
        }
      });
    }
  }, [orderid]);

  // current attachments get start
  useEffect(() => {
    const isAddNewOrder = localStorage.getItem("isAddNewOrder") === "true";
    const savedAttachments = localStorage.getItem("currentRentAttach");

    if (!orderid && !isAddNewOrder && savedAttachments) {
      setAttachments(JSON.parse(savedAttachments));
    }
  }, [orderid]);

  useEffect(() => {
    if (!orderid) {
      localStorage.setItem("currentRentAttach", JSON.stringify(attachments));
    }
  }, [attachments, orderid]);
  // current attachments get end

  // upload file with notification start
  const onFileUploaded = (data) => {
    console.log("asc22", data);
    const newDocuments = data.map((file) => ({
      documentname: file.name,
      documentextension: file.type,
      documentcontent: "string",
      link: file.link,
      documentsize: file.size,
      islocked: 0,
      //   uploadedbyfirstname: userFirstName,
      //   uploadedbylastname: userLastName,
      //   userId: userId,
    }));

    setAttachments((prevFileList) => [...prevFileList, ...newDocuments]);
    setIsDrawerOpen(true);

    // start other things from here
    let updatedDocInfo = data.map((x) => x?.link?.data);
    // props?.childData(updatedDocInfo);

    let payload = updatedDocInfo.map((item) => ({
      documentname: item.documentname,
      documentextension: item.documentExtension,
      documentsize: item.documentsize,
      link: item.link,
      documentcontent: "String",
      isStarted: 0,
      isClientSignature: 0,
    }));

    if (orderid) {
      dispatch(
        AdddocumenttoOrder({
          orderid: orderid,
          orderDocs: payload,
        }),
      );
    }
  };

  useEffect(() => {
    if (addPurchasingOrder.status === true) {
      let updatedDocInfo = attachments?.map((x) => x?.link.data);

      let payload = updatedDocInfo?.map((item) => ({
        documentname: item.documentname,
        documentextension: item.documentExtension,
        documentsize: item.documentsize,
        link: item.link,
        documentcontent: "String",
        isStarted: 0,
        isClientSignature: 0,
      }));
      dispatch(
        AdddocumenttoOrder({
          orderid: addPurchasingOrder?.data?.orderid,
          orderDocs: payload,
        }),
      );
    }
  }, [addPurchasingOrder]);

  const fileValidationBeforeUpload = (file) => {
    let isValid = true;
    // Check if the document with the same name already exists
    if (attachments.some((doc) => doc.documentname === file.name)) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "Document with the same name already exists.",
        },
        false,
      );
      isValid = false;
    }
    return isValid;
  };
  // upload file with notification end

  const [isDragging, setIsDragging] = useState(false);

  return (
    <>
      <div
        className="addPODocument"
        style={{
          ...style,
          pointerEvents: isDisabled ? "none" : "auto",
          border: isDragging ? "2px dashed blue" : "",
        }}
        onDragEnter={(e) => {
          e.preventDefault();
          setIsDragging(true); // 👈 Jab drag start ho
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setIsDragging(false); // 👈 Jab drag bahar chala jaaye
        }}
        // on drag upload img start
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true); // 👈 set to true when dragging.
        }}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false); // 👈 reset when drag leaves.
          const droppedFiles = Array.from(e.dataTransfer.files);

          // make onDrop data structure like we getting from InsertDocToS3 api
          const formattedFiles = droppedFiles.map((file) => ({
            name: file.name,
            size: file.size,
            type: file.type,

            // uploader jaisa structure
            link: {
              data: {
                documentname: file.name,
                documentExtension: file.type,
                documentsize: file.size,
                link: URL.createObjectURL(file),
              },
            },
          }));

          onFileUploaded(formattedFiles);
        }}
        // on drag upload img end
      >
        <DocumentUploaderWithProgress22
          maxSizeInMb={100}
          onUploaded={onFileUploaded}
          multiple={true}
          beforeFileUpload={fileValidationBeforeUpload}
        >
          <div className="d-flex gap-2 pointer px-2">
            <img src={attach} alt="" />
            <p className="mb-0">Attach a file ({attachments?.length || 0})</p>
            <span
              style={{
                pointerEvents: "auto",
              }}
              className="poViewAll"
              onClick={(e) => {
                e.stopPropagation();
                setIsDrawerOpen(!isDrawerOpen);
              }}
            >
              View All
            </span>
          </div>
        </DocumentUploaderWithProgress22>
      </div>

      <Drawer
        title={`Attachments (${attachments?.length || 0})`}
        mask={false}
        loading={showLoader}
        closable={{ "aria-label": "Close Button" }}
        onClose={() => setIsDrawerOpen(false)}
        open={isDrawerOpen}
        zIndex={9999}
      >
        {attachments?.map((item, DocIndex) => {
          return (
            <div
              className="poDocNameList d-flex justify-content-between align-items-start py-2"
              style={{ pointerEvents: isDisabled ? "none" : "auto" }}
            >
              {/* Left Side */}
              <div className="d-flex gap-2 align-items-center">
                <div className="mt-1">
                  {fileExtensionType(
                    item.documentname?.split(".").pop()?.toLowerCase(),
                    item.documentextension,
                  )}
                </div>

                <div className="min-width-0">
                  <p
                    className="mb-0 poFileName truncate"
                    style={{ maxWidth: "235px" }}
                    title={item.documentname}
                  >
                    {item.documentname}
                  </p>

                  <p className="mb-0 poFileSize">
                    {roundFileSize(item.documentsize)}
                  </p>
                </div>
              </div>

              {/* Right Side */}
              <div className="d-flex align-items-center gap-3 pt-1">
                {/* Download */}
                <div
                  className="pointer"
                  title="Download"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile(item?.link?.data?.link, item.documentname);
                  }}
                  style={{
                    pointerEvents: "auto",
                  }}
                >
                  <img src={downloadDoc} alt="" style={{ width: "16px" }} />
                </div>

                {/* Delete */}
                <span
                  title="Delete"
                  className="pointer text-danger"
                  onClick={() => {
                    setAttachments((prev) =>
                      prev.filter((_, index) => index !== DocIndex),
                    );
                  }}
                >
                  <img className="dltIcon pointer" src={DeleteIcon} alt="" />
                </span>
              </div>
            </div>
          );
        })}
        {attachments?.length === 0 && (
          <div className="text-center py-5">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
      </Drawer>
    </>
  );
};

export default AddPurchaseOrderDocument;
